

const inkConversations = {
  controller: 'ConversationsController',
  template: require('./conversations.template.html'),
  bindings: {
    $transition$: '<',
    data: '<'
  }
};

angular
  .module('inkfinder')
  .component('inkConversations', inkConversations);



// WEBPACK FOOTER //
// ./components/messages/conversations/conversations.component.js